const SvgIconPlayCircle = (props) => (
  <svg {...props}>
    <g fill="currentColor">
      <path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-.96C11.275 47.04.96 36.725.96 24S11.275.96 24 .96 47.04 11.275 47.04 24 36.725 47.04 24 47.04z" />
      <path d="M34.48 23.071l-16.917-9.928c-.694-.407-1.563.105-1.563.918v19.878c0 .813.868 1.325 1.563.918l16.917-9.93c.693-.425.693-1.45 0-1.856z" />
    </g>
  </svg>
)

export default SvgIconPlayCircle
